export default __webpack_public_path__ + "static/media/claim-records.55aa4a68.svg";